const initialState = {
  sale_orders: [],
  all_customers: [],
  all_vendors: [],
  all_purchase_orders: [],
};
const orderReducers = (state = initialState, action) => {
  switch (action.type) {
    case "ALL_SALE_ORDERS":
      return {
        ...state,
        sale_orders: action.payload,
      };
    case "ALL_PURCHASE_ORDERS":
      return {
        ...state,
        all_purchase_orders: action.payload,
      };
    case "ALL_CUSTOMERS":
      return {
        ...state,
        all_customers: action.payload,
      };
    case "ALL_VENDORS":
      return {
        ...state,
        all_vendors: action.payload,
      };
    default:
      return state;
  }
};
export default orderReducers;
